// Voorleesknop op het bord: de schakelaar per gezinslid (readAloudApp.nl.ts).
export const appReadAloudAr = {
    setting: 'زر القراءة بصوت عالٍ على اللوحة',
    settingHint: 'زر كبير يقرأ المهام والمواعيد والرسائل بصوت عالٍ. مفيد لمن لا يقرأ بعد.',
    language: 'لغة القراءة بصوت عالٍ والنداءات',
    languageHint: 'تقرأ اللوحة المهام والمواعيد والنداءات بهذه اللغة. تُقرأ العناوين كما تكتبها.',
    languageBoard: 'لغة اللوحة ({language})',
    languageMember: 'لغة القراءة بصوت عالٍ',
    languageMemberHint: 'تُقرأ العناوين كما تكتبها.',
    languageFamily: 'مثل العائلة ({language})',
    saved: 'تم الحفظ',
};
//# sourceMappingURL=readAloudApp.ar.js.map